import React, { ReactElement } from 'react';
import { useEntites } from '../../../Utils/api';
import TableSimple from '../Utils/TableSimple';
import { Colonne } from '../Utils/TypesTableSimple';
import { Erreur } from '../../../../../common/src/entities';
import EnteteDePage from '../Utils/EnteteDePage';

export default function Erreurs(): ReactElement {
    const erreurs = useEntites(Erreur);
    const colonnes: Colonne<Erreur>[] = [
        {
            Header: 'Nom',
            accessor: 'name',
        },
        {
            Header: 'Message',
            accessor: 'message',
        },
        {
            Header: 'Stack',
            accessor: 'stack',
        },
    ];
    return (
        <>
            <EnteteDePage texte="Erreurs" cacherBoutonRetour />
            <TableSimple colonnes={colonnes} resultat={erreurs} hover />
        </>
    );
}
